interface GraphqlErrorLike {
  message?: unknown;
  extensions?: {
    code?: unknown;
  };
}

function getGraphqlErrors(error: unknown): readonly GraphqlErrorLike[] {
  if (!error || typeof error !== 'object') {
    return [];
  }

  const errors = (error as { errors?: unknown }).errors;
  return Array.isArray(errors) ? errors : [];
}

export function isInvalidAccessTokenError(error: unknown): boolean {
  return getGraphqlErrors(error).some((graphqlError) => {
    const message =
      typeof graphqlError.message === 'string' ? graphqlError.message.trim() : '';
    const code = graphqlError.extensions?.code;

    return code === 'UNAUTHENTICATED' && /^Invalid access token/i.test(message);
  });
}
